var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.editMode && _vm.item)?_c('config-item-values',{attrs:{"item":_vm.item},on:{"value-created":_vm.valueCreated}}):_vm._e(),_vm._v(" "),(_vm.editMode)?_c('config-item-add-edit',{attrs:{"item":_vm.item}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }